import { UppKonvaShape } from '../upp-konva-shape';
import type { UppKonvaStairsShapeOptions } from '../upp-konva-options';

/** Stairs shape. */
export class UppKonvaStairsShape extends UppKonvaShape {
    // 1. Type contract
    readonly kind = 'STAIRS' as const;

    // 2. Lifecycle
    constructor(opts: UppKonvaStairsShapeOptions) {
        const { shape, ...rest } = opts;
        super({ ...rest, data: { shape } });
    }
}
